import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { Box, Button, Dialog, DialogTitle, DialogContent } from '@mui/material';

import { userCreateMessageFunc } from 'src/context/messages/user_createMessage';

import { toast } from 'src/components/snackbar';
import { Form, Field } from 'src/components/hook-form';

interface IOnboardingPopupProps {
  open: boolean;
  onClose: () => void;
  activityId: string;
  receiverId: string;
}

interface IMessageData {
  messageInput: {
    content: string;
    attachments: string[];
  };
  activityId: string;
  receiverId: string;
}

const OnboardingPopup = (props: IOnboardingPopupProps) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    props.onClose();
  };

  const currentValues = {
    message: '',
  };

  const defaultValues = {
    message: '',
  };

  const methods = useForm({
    mode: 'all',
    defaultValues,
    values: currentValues,
  });

  const { handleSubmit } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      dispatch(
        userCreateMessageFunc({
          activityId: props.activityId,
          receiverId: props.receiverId,
          messageInput: {
            content: data.message,
            attachments: [],
          },
        } as IMessageData)
      );

      toast.success(
        'Mesajınız başarıyla gönderildi. Organizatör cevaplayınca tarafınıza bildirim olarak iletilecektir.',
        {
          position: 'bottom-right',
        }
      );
      handleClose();
    } catch (error) {
      console.error(error);
    }
  });

  return (
    <Dialog onClose={handleClose} onSubmit={onSubmit} open={props.open}>
      <DialogTitle>Organiztöre Sorun</DialogTitle>
      <DialogContent>
        <Box sx={{ maxWidth: 800 }}>
          <Form methods={methods}>
            <Box
              sx={{
                rowGap: 1,
                columnGap: 2,
                display: 'grid',
                gridTemplateColumns: { xs: 'repeat(1, 1fr)' },
                mb: 3,
              }}
            >
              <Field.Editor
                name="message"
                placeholder="Aktivite ile ilgili sorunuzu organizatöre sorabilirsiniz"
              />
              <Button type="submit" variant="contained" sx={{ mt: 1, mr: 1 }}>
                Gönder
              </Button>
            </Box>
          </Form>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingPopup;
